import { currencyConstraints } from "src/constraints";

const yearPattern = /[0-9]{4}/;
const ssnPattern = /^\d{3}-?\d{2}-?\d{4}$/;
const datePattern = /^\d{1,2}\/\d{1,2}\/(\d{2}){1,2}$/;

export const ssnField = ({ t, inputProps = {}, ...props }) => ({
  key: "ssn",
  label: "Social Security Number",
  required: true,
  constraints: {
    format: {
      pattern: ssnPattern,
      message: `^${t("olb.security.ssnErrorMessage")}`,
    },
  },
  inputProps: {
    placeholder: "###-##-####",
    type: "password",
    ...inputProps,
  },
  ...props,
});

export const dobField = ({ t, inputProps = {}, ...props }) => ({
  key: "dob",
  label: t("olb.verification.dob", {
    defaultValue: "What is the primary member's date of birth?",
  }),
  constraints: {
    optionalFormat: {
      pattern: datePattern,
      message: `^${t("olb.verification.dobErrorMessage")}`,
    },
  },
  inputProps: {
    placeholder: "MM/DD/YYYY",
    format: value => {
      const digits = (value || "").match(/\d/g) || [];
      return digits
        .reduce(
          (acc, c, index) =>
            index === 2 || index === 4 ? `${acc}/${c}` : `${acc}${c}`,
          ""
        )
        .substr(0, 10);
    },
    ...inputProps,
  },
  ...props,
});

const codeField = ({ t }) => ({
  key: "code",
  label: "Code",
  required: true,
  inputProps: {
    autoFocus: true,
    autoComplete: "off",
  },
});

const nicknameField = ({ t }) => ({
  key: "nickname",
  label: "Nickname",
  required: true, // Only applies if `remember` is true. Otherwise this field is suppressed.
});

export const deviceOOBFields = ({ t }) => [
  codeField({ t }),
  {
    key: "remember",
    label: t("olb.oob.rememberCheckbox", {
      defaultValue: "Trust this device for future logins",
    }),
    type: "checkbox",
  },
  ({ values }) => (values.remember ? nicknameField({ t }) : null),
];

export const tier3OOBFields = ({ t }) => [codeField({ t })];

export const verificationFieldKeys = {
  last6Pan: "last6Pan",
  dob: "dob",
  yearAccountOpened: "yearAccountOpened",
};

export const verificationFields = ({ t, inputProps }) => ({
  type: "section",
  title: "Verify your identity (Only 2 Required)",
  fields: [
    {
      key: verificationFieldKeys.last6Pan,
      label: t("olb.verification.last6", {
        defaultValue:
          "What are the last 6 digits of your Financial Center debit card number?",
      }),
      constraints: {
        optionalFormat: {
          pattern: /^(\d){6}$/,
          message: `^${t("olb.verification.last6Validation", {
            defaultValue: "Must contain the last 6 digits",
          })}`,
        },
      },
      inputProps: {
        placeholder: "######",
        format: value => {
          // Strip out non-numeric values
          const digits = (value || "").match(/\d/g) || [];
          return digits.join("").substr(0, 6);
        },

        ...inputProps,
      },
    },
    dobField({
      key: verificationFieldKeys.dob,
      label: t("olb.verification.dob"),
      inputProps,
      t,
    }),
    {
      key: verificationFieldKeys.yearAccountOpened,
      label: t("olb.verification.yearAccountOpened", {
        defaultValue: "What year was your account opened?",
      }),
      helpText: t("olb.verification.yearAccountOpenedHelpText"),
      constraints: {
        optionalFormat: {
          pattern: yearPattern,
          message: `^Please make sure the year entered is 4 digits long`,
        },
      },
      inputProps: {
        placeholder: "YYYY",
        format: value => {
          // Strip out non-numeric values
          const digits = (value || "").match(/\d/g) || [];
          return digits.join("").substr(0, 4);
        },
        ...inputProps,
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/banking/authentication/sharedFields.js